<template>
	<div :class="style()" class="action item-container">
		<div class="action full-width flex-between" @click="clickHandler">
			<div class="flex-between label-name">{{ name }}</div>
			<div class="flex-between label-value">
				<span class="margin-right link">{{ value }}</span>
				<BaseIcon v-if="accessory"
					:class="iconStyle()"
					:icon="accessory"
					:isCustom="determineCustom(accessory)" />
			</div>
		</div>
	</div>
</template>

<script>
	import { includes } from 'lodash';
	export default {
		props: {
			action: {
				type: Object,
				default: () => {
					return {};
				}
			},
			name: {
				type: String,
				default: 'Info Name',
			},
			value: {
				type: String,
				default: 'Info Value',
			},
			accessory: {
				type: String,
				default: 'backChevron',
			},
			hideBorder: {
				type: Boolean,
				default: false,
			},
			clickHandler: {
				type: Function,
				default: () => {},
			},
			flip: {
				type: Boolean,
				default: false,
			},
			disabled: {
				type: Boolean,
				default: false,
			},
			error: {
				type: Boolean,
				defaults: false,
			},
		},
		methods: {
			style() {
				return {
					'hide-border': this.hideBorder,
					'disabled': this.disabled,
					'error': this.error,
				};
			},
			iconStyle() {
				return {
					'flip': this.flip,
				};
			},
			// TODO remove the need for this method
			//	we should not have to determine custom icons vs font awesome icons
			//	from outside containers.
			determineCustom() {
				const customIcons = [
					'backChevron',
				];
				const iconName = this.accessory;
				return includes(customIcons, iconName);
			},
		},
	}
</script>

<style lang="scss" scoped>
	@import 'commonStyle/form';
	.hide-border {
		border-bottom: none;
	}
	.flip {
		transform: scaleX(-1);
	}
	.flex-between {
		&.label-value {
			align-items: center;
		}
	}
	.disabled * {
		color: $storeButtonDisabled !important;
	}
	.error * {
		color: $danger !important;
	}
	@include extra-small {
		.link {
			font-size: 10pt;
		}
	}
</style>


// WEBPACK FOOTER //
// src/components/common/BaseActionItem.vue